import { render, staticRenderFns } from "./examHeader.vue?vue&type=template&id=4df2931d&scoped=true"
import script from "./examHeader.vue?vue&type=script&lang=js"
export * from "./examHeader.vue?vue&type=script&lang=js"
import style0 from "./examHeader.vue?vue&type=style&index=0&id=4df2931d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df2931d",
  null
  
)

export default component.exports